import AssetProjectList from '../../components/assetProjects/AssetProjectList';
import React from 'react';

const AssetProjectsPage: React.FC = () => {

    return (<div>
        <AssetProjectList />
    </div>)
};

export default AssetProjectsPage;